export type CategoryType =
  | 'STELE'
  | 'TOMB'
  | 'FOUNDATION'
  | 'PLATING'
  | 'BOX'
  | 'SIDEWALKS'
  | 'SOLE'
  | 'ANY'
  | 'VASE'
  | 'FLOWER'
  | 'URNS'
  | 'ANY_ACCESSORY'
  | string;

export const categoriesLabels: { key: CategoryType; label: string }[] = [
  {
    key: 'STELE',
    label: 'Stèle',
  },
  {
    key: 'TOMB',
    label: 'Tombale',
  },
  {
    key: 'FOUNDATION',
    label: 'Soubassement',
  },
  {
    key: 'PLATING',
    label: 'Placage',
  },
  {
    key: 'BOX',
    label: 'Coffret',
  },
  {
    key: 'SIDEWALKS',
    label: 'Trottoir',
  },
  {
    key: 'SOLE',
    label: 'Semelles',
  },
  {
    key: 'ANY',
    label: 'Autre piece',
  },
  {
    key: 'VASE',
    label: 'Vases',
  },
  {
    key: 'FLOWER',
    label: 'Jardinières',
  },
  {
    key: 'URNS',
    label: 'Urnes',
  },
  {
    key: 'ANY_ACCESSORY',
    label: 'Autre accessoire',
  },
];

export const GranitCategories = [
  'BLACK',
  'WHITE',
  'GREY',
  'BEIGE',
  'PINK',
  'BROWN',
  'RED',
  'GREEN',
  'BLUE',
  'ORANGE',
];
export type GranitCategory = (typeof GranitCategories)[number];

export const granitCategoriesLabels: { key: GranitCategory; label: string }[] = [
  {
    key: 'BLACK',
    label: 'Noir',
  },
  {
    key: 'WHITE',
    label: 'Blanc',
  },
  {
    key: 'GREY',
    label: 'Gris',
  },
  {
    key: 'BEIGE',
    label: 'Beige',
  },
  {
    key: 'PINK',
    label: 'Rose',
  },
  {
    key: 'BROWN',
    label: 'Marron',
  },
  {
    key: 'RED',
    label: 'Rouge',
  },
  {
    key: 'GREEN',
    label: 'Vert',
  },
  {
    key: 'BLUE',
    label: 'Bleu',
  },
  {
    key: 'ORANGE',
    label: 'Orange',
  },
];
